// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRolloverTransferRequestDto
 */
export interface IRolloverTransferRequestDto {
    /**
     * 
     * @type {number}
     * @memberof IRolloverTransferRequestDto
     */
    amount: number;
}

/**
 * Check if a given object implements the IRolloverTransferRequestDto interface.
 */
export function instanceOfIRolloverTransferRequestDto(value: object): value is IRolloverTransferRequestDto {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function IRolloverTransferRequestDtoFromJSON(json: any): IRolloverTransferRequestDto {
    return IRolloverTransferRequestDtoFromJSONTyped(json, false);
}

export function IRolloverTransferRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRolloverTransferRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
    };
}

export function IRolloverTransferRequestDtoToJSON(json: any): IRolloverTransferRequestDto {
    return IRolloverTransferRequestDtoToJSONTyped(json, false);
}

export function IRolloverTransferRequestDtoToJSONTyped(value?: IRolloverTransferRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
    };
}

